import Angular from "angular";
import Controller from "./new-booking-service.controller";
import Template from "./new-booking-service.html";
import Servies from "../../services/services.service";

export const NewBookingServiceView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.new-booking-service', [Servies.name]);



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-service/new-booking-service.js